// extracted by mini-css-extract-plugin
export default {"pageWrap":"HouseModelRoot_pageWrap__WLYw3"};